import React, { Component } from 'react'
import { connect } from 'react-redux'
import { chatKeys, doorkeyKeys, homeNaviation,bookVirginListAtTabClickKeys,locationSelectorWidget,notificationKeys, theKnowKeys, myTripsKeys } from '../../../config/layout2constant'
import { musicWidgetTypes } from '../../../config/layout2constant'
import { CMSPath } from '../../../config/constant'
import { Link, HashRouter } from 'react-router-dom'
import { setCurrentHomePage, setCurrentHomePageBeforeNotificationTab } from '../../action/homeAction'
import { footerColor } from '../../JS/colorConfig'
import { setCurrentTabNavItemList } from '../../action/action'
import ChatBubble from '../chatWidget/chatBubble'
import DoorKey from '../../../UI/doorKey/doorKey'
import { currentWidget } from '../../../action/action'

class FooterNavigation extends Component {

    returnNotificationTab = () => {
        let tab = this.props.footerTabList[0];

        if(this.props.footerTabList){
        this.props.footerTabList.forEach((item,index) => {
            if (notificationKeys.some(el => el === item.uniqueKey.toLowerCase()) || item.tabName.replace(/ /g,'').toLowerCase() === "notifications"){
                tab = this.props.footerTabList[index]
            }
        });
        }

        return tab;
    }

    returnMyStayTab = () => {
        let myStayTab = this.props.footerTabList[0];

        if(this.props.footerTabList){
            this.props.footerTabList.forEach((item,index) => {
                if (item.uniqueKey.replace(/ /g,'').toLowerCase() === "mystay"){

                    const matchedWidgetItem = this.props.widgetList.find(widgetItem => 
                        widgetItem.uniqueKey.replace(/ /g,'').toLowerCase() === item.uniqueKey.replace(/ /g,'').toLowerCase()
                    );

                    if (matchedWidgetItem && matchedWidgetItem.widgets.length > 0) {
                        myStayTab = this.props.footerTabList[index];
                    }
                }
            });
        }

        return myStayTab;
    }

    returnRequiredTab = (bottomTabID) => {
        let tab = this.props.footerTabList[0];

        if(this.props.footerTabList && bottomTabID){
            this.props.footerTabList.forEach((item,index) => {
                if ((item.uniqueKey.toLowerCase() == bottomTabID.toLowerCase()) || (item.tabName.replace(/ /g,'').toLowerCase() == bottomTabID.toLowerCase())){
                    tab = this.props.footerTabList[index]
                }
            });
        }

        return tab;
    }

    /**
     * we are selecting  default tab for navigation which will be first tab.
     * we are also selecting widget list of selected tab.
     */
    componentDidUpdate(prevProps) {
       // footerColor(this.props.menuColor)
       if (prevProps.footerTabList !== this.props.footerTabList) {
            let selectedTab = this.getSelectedFooterTabAtAppStart();

            if (!this.props.selectedHomePage.uniqueKey) {
                // console.log("we are in this.", this.props.footerTabList[0])
                this.props.setCurrentHomePage(selectedTab);
                this.props.widgetList.map((item) => {
                    if (item.uniqueKey === selectedTab.uniqueKey || item.uniqueKey === selectedTab.tabName.replace(/ /g,'').toLowerCase()) {
                        this.props.setCurrentTabNavItemList(item.widgets);
                    }
                })
            }
        }
    }

    getSelectedFooterTabAtAppStart = () => {
        let room = localStorage.getItem('room');

        if(sessionStorage.getItem("bottomTabID")){
            let requireTab = this.returnRequiredTab(sessionStorage.getItem("bottomTabID"));
            return requireTab;
        }

        if((room && room !== 'null') || (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) {
            let initialTab = localStorage.getItem("checkFirebaseMessageReceived") == "true" ? this.returnNotificationTab() : this.returnMyStayTab();
            return initialTab;
        } 
        
        return this.props.footerTabList[0];
    }

    componentDidMount() {
        // footerColor(this.props.menuColor)
       let selectedTab = this.getSelectedFooterTabAtAppStart();
       

       // update tab after pre check-in
        if (this.props.footerTabList && this.props.preCheckInBookingDueIn && !sessionStorage.getItem("updateFooterAfterPreCheckIn")) {
            sessionStorage.setItem("updateFooterAfterPreCheckIn", true)
            this.props.setCurrentHomePage(selectedTab);
            this.props.widgetList.map((item) => {
                if (item.uniqueKey === selectedTab.uniqueKey || item.uniqueKey === selectedTab.tabName.replace(/ /g,'').toLowerCase()) {
                    this.props.setCurrentTabNavItemList(item.widgets);
                }
            })
        }
    }

    /**
     * on Click of tab in footer we are going to set it as selected tab.
     * we are also going select widget list of selected tab.
     */
    onNavClick = (obj) => {
        localStorage.removeItem("checkFirebaseMessageReceived");
        sessionStorage.removeItem("bottomTabID");

        const isNotificationTab = notificationKeys.some(el => el === obj.uniqueKey.toLowerCase());
        const isLocationTab = locationSelectorWidget.some(el => el === obj.uniqueKey.toLowerCase());
        
        
        if(isNotificationTab || isLocationTab ){
            this.props.setCurrentHomePageBeforeNotificationTab(this.props.selectedHomePage);   
        }

        this.props.setCurrentHomePage(obj);
        console.log("this.props.footerTabList",obj)
        this.props.widgetList.map((item) => {
            if (item.uniqueKey === obj.uniqueKey || item.uniqueKey === obj.tabName.replace(/ /g,'').toLowerCase()) {
                this.props.setCurrentTabNavItemList();
                this.props.setCurrentTabNavItemList(item.widgets);
            }
        })
    }

    getNewNotCount = (notifications) => {
        if(!notifications || notifications == "null"){
            return 0;
        }

        let count = 0;

        for(let obj of notifications){
            if(obj.status === "NEW"){
                count = count + 1;
            }
        }

        return count;
    }


    onLocationWidgetClick = (obj) => {
        // this.props.currentWidget({widgetType: "Hotel Selector"}) 
        this.onNavClick(obj)
    }

    onMusicWidgetClick = (obj) => {
        // this.props.currentWidget({widgetType: "Hotel Selector"}) 
        this.onNavClick(obj)
    }

    footerImages = (type) => {
        switch (type) {
            case 'explore':
                return (
                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.66 55.45">
                        <title>ico_explore</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <path d="M75.15,31.8h0l-.1-.17a18.07,18.07,0,0,0-1.34-2.35l-13.17-23h0A11,11,0,0,0,40.19,7.67H36.47A11,11,0,0,0,16.1,6.23h0L2.93,29.28a17.15,17.15,0,0,0-1.35,2.36l-.09.16h0A16.73,16.73,0,0,0,30.58,48.13h15.5A16.73,16.73,0,0,0,75.15,31.8ZM18.06,50.05A12.89,12.89,0,1,1,30.94,37.16,12.89,12.89,0,0,1,18.06,50.05Zm42,0A12.89,12.89,0,1,1,72.9,37.16,12.89,12.89,0,0,1,60,50.05Z" />
                            </g>
                        </g>
                    </svg>
                )
            case 'myStay':
                return (
                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.15 47.25">
                        <title>ico_my_stay</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <path d="M8.59,13.81a6,6,0,0,1,6-6h18a6,6,0,0,1,6,6,6,6,0,0,1,6-6h18a6,6,0,0,1,6,6v1.82h2.11V7a7,7,0,0,0-7-7H13.48a7,7,0,0,0-7,7v8.63H8.59Z" />
                                <path d="M16.22,10.17a4.49,4.49,0,0,0-4.48,4.49v1h24v-1a4.49,4.49,0,0,0-4.49-4.49Z" />
                                <path d="M46.22,10.21a4.49,4.49,0,0,0-4.49,4.49v1h24v-1a4.49,4.49,0,0,0-4.48-4.49Z" />
                                <path d="M73.15,18.44H4a4,4,0,0,0-4,4V37.53a4,4,0,0,0,3.66,4l-1.13,4s-.15,2.78,2.74,1.39l3.46-5.33H68.42l3.46,5.33c2.88,1.39,2.74-1.39,2.74-1.39l-1.14-4a4,4,0,0,0,3.67-4V22.44A4,4,0,0,0,73.15,18.44Z" />
                            </g>
                        </g>
                    </svg>
                )
            case 'notifiction':
                return (
                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.11 65.51">
                        <title>ico_notify</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <path d="M50.93,49.18c-3.57-2.44-4.51-10.7-4.51-10.7V24.4C45.09,14.21,37,9.91,31.4,8.13V5.35a5.35,5.35,0,1,0-10.7,0V8.13C15.13,9.91,7,14.21,5.69,24.4V38.48s-.94,8.26-4.51,10.7,2.07,6.38,2.07,6.38a121.78,121.78,0,0,0,15.92,3.87,6.94,6.94,0,0,0,13.77,0,121.78,121.78,0,0,0,15.92-3.87S54.49,51.62,50.93,49.18Z" />
                            </g>
                        </g>
                    </svg>
                )
            default:
                console.log("Issue with images.")
        }
    }

    render() {
        // console.log("this.props.widgetList",this.props.widgetList)
        return (
            <footer>
                <HashRouter>
                    <div class="nav">
                        {
                            this.props.footerTabList ?
                                this.props.footerTabList.map((item) => {
                                    if (notificationKeys.some(el => el === item.uniqueKey.toLowerCase()) || item.tabName.replace(/ /g,'').toLowerCase() === "notifications") {
                                        return (
                                            <Link
                                                onClick={() => this.onNavClick(item)}
                                                className={
                                                    this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                        "footButton selected" : "footButton"
                                                }
                                                exact to="/notifications"
                                            >
                                                { 
                                        
                                                    this.getNewNotCount(this.props.notifications)>0 ? <div class="alert unread">
                                                        {this.getNewNotCount(this.props.notifications)}
                                                    </div>
                                                    
                                                    :this.props.notifications && this.props.notifications.length > 0 ? <div class="alert ">
                                                        {this.props.notifications.length}
                                                    </div>

                                                    : null
                                                
                                                }
                                                <span class="button-icon">
                                                    <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="not found" />
                                                </span>
                                                <span class="button-label">{item.tabName}</span>
                                            </Link>
                                        )
                                    }

                                    if(chatKeys.some(el => el === item.uniqueKey.toLowerCase())){
                                        return (
                                            <ChatBubble navbar={true} widgetInfo={item} />
                                        )
                                    }

                                    if(doorkeyKeys.some(el => el === item.uniqueKey.toLowerCase())){
                                        return (
                                            <DoorKey navbar={true}  widgetInfo={item} />
                                        )
                                    }

                                    if(locationSelectorWidget.some(el => el === item.uniqueKey.toLowerCase())){
                                        return (
                                            <Link
                                                onClick={() => this.onLocationWidgetClick(item)}
                                                className={
                                                    this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                        "footButton selected" : "footButton"
                                                }
                                                exact to="/selectHotel"
                                            >
                                                <span class="button-icon">
                                                    <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="Locations" />
                                                </span>
                                                <span class="button-label">{item.tabName}</span>
                                            </Link>
                                        )
                                    }
                                    if((theKnowKeys.some(el => el === item.uniqueKey.toLowerCase()) && this.props.externalSignIn.memberId) || (myTripsKeys.some(el => el === item.uniqueKey.toLowerCase()) && this.props.externalSignIn.memberId) ){
                                        return (
                                            <Link
                                                onClick={() => {console.log("theKnowKeys executing"); this.onNavClick(item);}}
                                                className={
                                                    this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                        "footButton selected" : "footButton"
                                                }
                                                exact to="/theKnow"
                                            >
                                                <span class="button-icon">
                                                    <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="the-know" />
                                                </span>
                                                <span class="button-label">{item.tabName}</span>
                                            </Link>
                                        )
                                    }

                                    if(bookVirginListAtTabClickKeys.some(el => el === item.uniqueKey.toLowerCase())){
                                        return (
                                            <Link
                                                onClick={() => {console.log("bookVirginListAtTabClickKeys executing"); this.onNavClick(item);}}
                                                className={
                                                    this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                        "footButton selected" : "footButton"
                                                }
                                                exact to="/book-virgin"
                                            >
                                                <span class="button-icon">
                                                    <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="book virgin" />
                                                </span>
                                                <span class="button-label">{item.tabName}</span>
                                            </Link>
                                        )
                                    }

                                    if(musicWidgetTypes.some(el => el === item.uniqueKey.toLowerCase())){
                                        return (
                                            <Link
                                                onClick={() => this.onMusicWidgetClick(item)}
                                                className={
                                                    this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                        "footButton selected" : "footButton"
                                                }
                                                exact to="/music"
                                            >
                                                <span class="button-icon">
                                                    <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="Locations" />
                                                </span>
                                                <span class="button-label">{item.tabName}</span>
                                            </Link>
                                        )
                                    }

                                    return (
                                        <Link
                                            onClick={() => this.onNavClick(item)}
                                            className={
                                                this.props.selectedHomePage.uniqueKey === item.uniqueKey ?
                                                    "footButton selected" : "footButton"
                                            }
                                            exact to="/"
                                        >
                                            <span class="button-icon">
                                                <img src={`${CMSPath}${(this.props.selectedHomePage.uniqueKey === item.uniqueKey && item.tabFocusedIconUrl) ? item.tabFocusedIconUrl : item.tabIconUrl}`} alt="not found" />
                                            </span>
                                            <span class="button-label">{item.tabName}</span>
                                        </Link>
                                    )
                                }) : null
                        }
                    </div>
                </HashRouter>
            </footer >
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedHomePage: state.store2.currentHomePage,
        menuColor: state.store.home.MenuColor,
        preCheckInBookingDueIn: state.store2.preCheckInBookingDueIn,
        widgetList: state.store2.sideNavBar.widgetList,
        footerTabList: getTabs(state.store.home.currentDuration),
        notifications: state.store.home.gJnotifications,
        externalSignIn: state.store2.externalSignIn,
    }
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}
export default connect(
    mapStateToProps,
    {
        setCurrentHomePage,
        currentWidget,
        setCurrentHomePageBeforeNotificationTab,
        setCurrentTabNavItemList,
    }
)(FooterNavigation);
